import type { PaginationOptions, PaginationProgress } from '../types';
import { assertPageOk } from './assertPageOk';
import { readPath } from './readPath';

// gloss
export const readPage = async <R, T, Q>(
  options: PaginationOptions<R> & { fetchPage: (request: Q, page: number) => Promise<R> },
  request: Q,
  progress: PaginationProgress,
  label: string,
  dataKey: string,
): Promise<{ response: R; items: T[] }> => {
  const page = progress.pages + 1;
  const response = await options.fetchPage(request, page);
  assertPageOk(response, { label, page, isError: options.isError });
  options.onResponse?.(response, page);

  const items = readPath(response, dataKey) ?? [];
  if (!Array.isArray(items)) throw new Error(`${label}: page ${page} has no array at ${dataKey}`);
  progress.pages = page;
  progress.rows += items.length;
  return { response, items };
};
